import React from 'react'
import SecondRowBoxes from './SecondRowBoxes/SecondRowBoxes'
import FirstRowBoxes from './FirstRowBoxes/FirstRowBoxes'
import ThirdRowBoxes from './ThirdRowBoxes/ThirdRowBoxes'

function ExampleBoxes () {
  return (
    <section>
      <FirstRowBoxes />
      <SecondRowBoxes />
      <ThirdRowBoxes />
    </section>
  )
}

export default ExampleBoxes
